/** Norwegian architecture trade code used as the site datum when present. */
export const ARK_DISCIPLINE = "ARK";

export const isArkDiscipline = (discipline) =>
  String(discipline || "").trim().toUpperCase() === ARK_DISCIPLINE;

const sortOrderOf = (model) => Number(model?.sort_order ?? model?.sortOrder ?? 0) || 0;

const createdAtOf = (model) => String(model?.created_at || "");

/**
 * Site datum: ARK when any model has that discipline (sort_order among ARK),
 * otherwise first uploaded (sort_order, then created_at).
 */
export const pickDatumModel = (list) => {
  const models = Array.isArray(list) ? list : [];
  if (models.length === 0) return null;
  const ark = models
    .filter((model) => isArkDiscipline(model.discipline))
    .sort((a, b) => {
      const order = sortOrderOf(a) - sortOrderOf(b);
      if (order !== 0) return order;
      return createdAtOf(a).localeCompare(createdAtOf(b));
    });
  if (ark.length) return ark[0];
  return sortIfcModels(models)[0] || null;
};

export const pickDatumModelId = (list) => {
  const datum = pickDatumModel(list);
  return datum?.id != null ? String(datum.id) : null;
};

/** Manifest / rematch order: ARK first, then sort_order / created_at. */
export const sortIfcModels = (list) =>
  [...(list || [])].sort((a, b) => {
    const arkDelta =
      (isArkDiscipline(a.discipline) ? 0 : 1) -
      (isArkDiscipline(b.discipline) ? 0 : 1);
    if (arkDelta !== 0) return arkDelta;
    const order = sortOrderOf(a) - sortOrderOf(b);
    if (order !== 0) return order;
    return createdAtOf(a).localeCompare(createdAtOf(b));
  });
